import { IconX } from '@tabler/icons-react'
import Image from 'next/image'

import Button from 'shared/ui/Button'
import LinkButton from 'shared/ui/Button/LinkButton'
import { addTestId } from 'shared/utils/tests'

import {
  CategoryTypeWithCounter,
  ListingCategoryType,
  PageCategoryType
} from '../types/categories'

import styles from './CategoryTags.module.scss'

interface CategoryTagsProps {
  categories: CategoryTypeWithCounter<ListingCategoryType | PageCategoryType>[]
  mainCategory?: ListingCategoryType | null
  onClick?: (name: string, value: string | string[]) => void
  notVisible?: boolean
}

const CategoryTags = ({
  categories,
  mainCategory,
  onClick,
  notVisible
}: CategoryTagsProps) => {
  const handleClick = async (value: string | undefined) => {
    typeof onClick === 'function' && value && onClick('category', value)
  }

  return (
    <>
      <div className={styles.categoriesWrapper} {...addTestId('category-tags')}>
        {categories &&
          !notVisible &&
          categories.map(category => {
            const icon = category.icon?.path || '/static/question-mark.svg'
            const active = mainCategory?.id === category.id
            const counterText =
              category.count &&
              (!active ? `(${category.count})` : <IconX size={24} />)

            // @sieradz - halloween - remove this if and check findCategoryBySlug in entity
            // - we are looking for category that is hidden and is not given from backend
            // @Słowik
            if (!category.isVisible) {
              return null
            }

            if (onClick && category.slug) {
              return (
                <Button
                  key={category.id}
                  active={active}
                  onClick={() => handleClick(String(category.code))}
                  variant='neutralOutline'
                  startIcon={
                    <Image
                      src={icon}
                      width={24}
                      height={24}
                      alt={category.name}
                    />
                  }
                  {...addTestId('category-tag')}
                >
                  <span className={styles.categoryName}>
                    {category.name} {counterText}
                  </span>
                </Button>
              )
            }

            return (
              <LinkButton
                key={category.id}
                href={category?.totalSlug || ''}
                active={active}
                variant='neutralOutline'
                {...addTestId('category-tag')}
              >
                <Image src={icon} width={24} height={24} alt={category.name} />
                <span className={styles.categoryName}>
                  {category.name} {counterText}
                </span>
              </LinkButton>
            )
          })}
      </div>
    </>
  )
}

export default CategoryTags
